import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useState } from 'react';

import {
  Radio,
  Spin,
  Row,
  Typography,
  Select,
  notification,
  message,
  InputNumber,
  Form,
  Col,
} from 'antd';
import * as finEngine from 'services/finEngine';
import DF from 'DisplayFramework';
import { getRounding, toCurrency, toRate } from 'utils/utils';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import {
  getFinContractById,
  getFinModificationValidByCtrid,
  getFinModificationByModid,
  FinConElementResponse,
  getFinContractFutureValueList,
  getFinContractIrvScheduleList,
  reschUnpaidInvoice,
} from 'services/fincontract';
import SliderWithInput from 'components/SliderWithInput';
import { FormInstance } from 'antd/lib/form';

import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import InputRate from 'components/InputRate';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import _, { debounce, groupBy, isEmpty, isNil } from 'lodash';
import { conElementToElement } from 'pages/ProposalV3/PropDetail/conElementToElement';
import UtinaCard from 'components/UtinaCard';
import { AssetFutureValueScheduleResponse } from 'services/assets';
import {
  PropElementRequest,
  PropElementResponse,
  PropElemStepRequest,
} from 'services/proposal';
import {
  findCIByAnyRefOrStatusOrDate,
  FindCIByAnyRefOrStatusOrDateParams,
} from 'services/clientInvoice';
// import GetLabel from 'DisplayFramework/components/GetLabel';
import GetLabel from 'DisplayFramework/components/GetLabel';
import moment from 'moment';

const { Text } = Typography;

export type TabReschUnpaidInvProps = {
  objectid: number;
  object: string;
  form: FormInstance;
  setSuccessful?: any;
  entityReference: string;
};

const TabReschUnpaidInv = ({
  objectid,
  object,
  form,
  setSuccessful,
  entityReference,
}: TabReschUnpaidInvProps) => {
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    remainDuration: '?',
    outStanding: 0,
    newOutStanding: 0,
    fvamount: 0,
    fvamountend: 0,
    oldRental: 0,
    newRental: 0,
    effectDate: '',
    feesAmount: 0,
    feesFormula: '',
    newElements: [] as FinConElementResponse[],
    cteaprrate: 0,
    durationMax: 0,
    currentDuration:0
  });

  const { data: contract, isFetching: isLoading } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data ?? {}),
    { refetchOnMount: false, staleTime: 60 * 1000 * 5 }
  );

  
  const { data: modList, isFetching } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'RESCUNPAID',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  useEffect(() => {
    setSuccessful(isLoading && isFetching);
  }, [isLoading, isFetching]);

  const { data: irvList, isLoading: Loading } = useQuery(
    ['getFinContractIrvScheduleList', { ctrid: objectid }],
    () =>
      getFinContractIrvScheduleList({
        ctrid: objectid,
      }).then((res) => res.list),
    { refetchOnMount: false }
  );

  const { data: fvList } = useQuery(
    ['getFinContractFutureValueList', { ctrid: objectid }],
    () =>
      getFinContractFutureValueList({
        ctrid: objectid,
      }).then((res) => res.list ?? []),
    { refetchOnMount: false }
  );

  
  
  const updateState = useCallback(
    (values) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      updateState({ isModSelected: false });
      return;
    }
    
      // eslint-disable-next-line no-debugger
      //  debugger;

    updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    query.then((response) => {
      if (response.code !== '200') {
        return;
      }
      const res = response.data;

      form?.setFieldsValue({
        mode: 'REAL',
        effectDate: res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0]?.newvalue,
        // Spec Event :
        gpDuration: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'GPDURATION' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        // extendDuration: res.simulParams.filter(
        //   (item) => item.parcode === 'EXTENDDUR' && item.partype === 'IN'
        // )[0].newvalue,

        // new RV :
        newRv: res.simulParams.filter(
          (item) => item.parcode === 'NEWRV' && item.partype === 'IN'
        )[0]?.newvalue,

        //NEWDUEDATE
        newDueDate: res.simulParams.filter(
          (item) => item.parcode === 'NEWDUEDATE' && item.partype === 'IN'
        )[0]?.newvalue,

        //DEFINTMET
        defintMethod: res.simulParams.filter(
          (item) => item.parcode === 'DEFINTMET' && item.partype === 'IN'
        )[0]?.newvalue,
        //DEFINTRATE
        defintNominalRate: res.simulParams.filter(
          (item) => item.parcode === 'DEFINTRATE' && item.partype === 'IN'
        )[0]?.newvalue,

        //GPMETHOD
        gpMethod: res.simulParams.filter(
          (item) => item.parcode === 'GPMETHOD' && item.partype === 'IN'
        )[0]?.newvalue,
        //GPPERIOD
        gpPeriodicity: res.simulParams.filter(
          (item) => item.parcode === 'GPPERIOD' && item.partype === 'IN'
        )[0]?.newvalue,

        //GPRATE
        gpNominalRate: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'GPRATE' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        //REMDUR
        newRemainingDuration: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'REMDUR' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        //NEWRATE
        newRate: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'NEWRATE' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        // Fees :

        comment: response.data.modcomment,

        feesFormula: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
          )[0]?.newvalue
        ),
        feesAmount: res.simulParams.filter(
          (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
        )[0]?.newvalue,

        // modreason: res.simulParams.filter(
        //   (item) => item.parcode === 'MODREASON' && item.partype === 'IN'
        // )[0].newvalue,

      });
      updateState({
        isModSelected: true,
        remainDuration: res.simulParams.find(
          (item) => item.parcode === 'REMDUR' && item.partype === 'IN'
        )?.newvalue,
        outStanding: Number(
          res.simulParams.find(
            (item) => item.parcode === 'OUTSTAND' && item.partype === 'RESULT'
          )?.newvalue
        ),
        oldRental: res.simulParams.find(
          (item) => item.parcode === 'RENTAL' && item.partype === 'RESULT'
        )?.oldvalue,
        newRental: res.simulParams.find(
          (item) => item.parcode === 'RENTAL' && item.partype === 'RESULT'
        )?.newvalue,

      });

      const targetDate = form?.getFieldValue('effectDate');

      const defintMethod = form?.getFieldValue('defintMethod');
      const newDueDate = form?.getFieldValue('newDueDate');
      const defintNominalRate = form?.getFieldValue('defintNominalRate');

      const gpDuration = form?.getFieldValue('gpDuration');
      const gpMethod = form?.getFieldValue('gpMethod');
      const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
      const gpNominalRate = form?.getFieldValue('gpNominalRate');
      const extendDuration =
        gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

      const newRate = form?.getFieldValue('newRate');

      const newRv = form?.getFieldValue('newRv');

      const newRemainingDuration = form?.getFieldValue('newRemainingDuration');


      calculate(
        objectid,
        newRv ?? rvDefault,
        gpDuration,
        gpMethod,
        gpPeriodicity,
        gpNominalRate,
        extendDuration,
        newRemainingDuration,
        newRate,
        0,
        '',
        targetDate,
        newDueDate,
        defintMethod,
        defintNominalRate,
      );
      updateState({ isLoading: false, durationMax: newRemainingDuration, currentDuration: newRemainingDuration });
    });
  };

  const durationDefault = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.cteduration;

  const rvDefault = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.ctervamount;

  const dueDateDefault = contract?.conElements?.find(
    (e) => e.ctetype === 'FIN'
  )?.ctebilligdate;

  const durationMin = contract?.conElements?.find((e) => e.ctetype === 'FIN')
    ?.pricing?.durationmin;

    // const durationMax = contract?.conElements?.find((e) => e.ctetype === 'FIN')
  //   ?.pricing?.durationmax;
  useEffect(() => {
    const _cteenddate = contract?.conElements?.find(
      (e) => e.ctetype === 'FIN'
    )?.cteenddate;
  
    const _ctestartdate = contract?.conElements?.find(
      (e) => e.ctetype === 'FIN'
    )?.ctestartdate;
  
    if (_cteenddate && _ctestartdate) {
      const maxCteenddate = new Date(_cteenddate);
      const maxCtestartdate = new Date(_ctestartdate);
  
      const durMax =
        (maxCteenddate.getTime() - maxCtestartdate.getTime()) / (1000 * 3600 * 24 * 30);
  
      updateState({ durationMax: durMax , currentDuration: durationDefault});
    }
  }, [contract]);
  
  
  

  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter(
      (s) =>
        s.ciid === null &&
        s.ctstype !== 'UPFRONT' &&
        s.ctstype !== 'RV' &&
        s.ctstype !== 'DEFINT'
    );

  const optionDates = notInvoicedSchedule?.map(
    (e, index) =>
      e.ctstype !== 'UPFRONT' && (
        <option key={index} value={e.ctsduedate.toString()}>
          {e.ctsduedate}
        </option>
      )
  );

  const optionModListValid = modList?.map((e, index) => (
    <option key={index} value={e.modid}>
      {e.modid + ' - ' + e.modcomment}
    </option>
  ));

  const optionsMode = [
    { label: 'Simulation', value: 'SIMUL' },
    { label: 'Real', value: 'REAL' },
  ];



  const handledefintMethodChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    // //  no-// //
    // ////

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    //const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const newRv = form?.getFieldValue('newRv');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');
    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    //const newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    const newRate = form?.getFieldValue('newRate');


    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;
    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    updateState({durationMax: newRemainingDuration, currentDuration: newRemainingDuration});

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      value,
      defintNominalRate,
    );
  };

  const handledefintNominalRateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    // //  no-// //
    // ////

    const newRv = form?.getFieldValue('newRv');
    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    //const defintNominalRate = form?.getFieldValue('defintNominalRate');
    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    //const newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    const newRate = form?.getFieldValue('newRate');

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;
    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    updateState({durationMax: newRemainingDuration, currentDuration: newRemainingDuration});

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      value,
    );
  };

  const handleDueDateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }
    const newRv = form?.getFieldValue('newRv');
    const defintMethod = form?.getFieldValue('defintMethod');
    //const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');
    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    //const newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    const newRate = form?.getFieldValue('newRate');

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldValue('newRemainingDuration', newRemainingDuration);
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldValue('newRemainingDuration', newRemainingDuration);
    }

    updateState({durationMax: newRemainingDuration, currentDuration: newRemainingDuration});

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      value,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleGpDurationChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    const newRv = form?.getFieldValue('newRv');
    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    //const newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    const newRate = form?.getFieldValue('newRate');


    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + value;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    calculate(
      objectid,
      newRv,
      value,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const searchParams: FindCIByAnyRefOrStatusOrDateParams = {
    cidocreference: '',
    cireference: '',
    cistatus: '',
    citype: '',
    clientname: '',
    ctreference: entityReference,
    datemax: '',
    datemin: '',
    mgid: Number(localStorage.getItem('mgid')),
    paystatus: '',
    tpreference: '',
    currcode: '',
  };

  const [unpaidList, setUnpaidList] = useState<any[]>([]);

  // const clientInvoices = findCIByAnyRefOrStatusOrDate(
  //   searchParams
  // ).then((res) => res.list || []);

  const { data: clientInvoices } = useQuery(
    ['findCIByAnyRefOrStatusOrDate', searchParams],
    () => findCIByAnyRefOrStatusOrDate(searchParams).then((res) => res.list ?? []),
    { refetchOnMount: false, staleTime: 60 * 1000 * 5 }
  );
  
  const handleEffectDateChange = (value: any) => {

    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    // const ciShedule= contract?.conElements
    //   ?.find((e) => e.ctetype === 'FIN')
    //   ?.conElemSchedules.filter(
    //     (s) =>
    //       s.cisdu < moment(Date.now()).format('YYYY-MM-DD')
    //   );

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration') ?? 0;
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

  
    const newRate = form?.getFieldValue('newRate');

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= value
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    const outstanding = notInvoicedSchedule?.find(
      (e) => e.ctsduedate === value
    )?.ctsstartamount;

    const fvvalue: Array<AssetFutureValueScheduleResponse> =
      fvList?.filter((e) => e?.prcode === 'LEASING')[0]?.fvSchedule ?? [];

    const fvamount = fvvalue?.find((e) => e.fvdate === value)?.fvamount;

    const fvamountend = fvvalue[fvvalue.length - 1]?.fvamount;

    const oldRental = notInvoicedSchedule?.find(
      (e) => e.ctsduedate === value
    )?.ctsrentalamount;

    state.fvamount = fvamount ?? 0;
    state.fvamountend = fvamountend ?? 0;
    state.remainDuration = String(fremainDuration);
    state.outStanding = outstanding ?? 0;
    state.newOutStanding = outstanding ?? 0;
    state.oldRental = oldRental ?? 0;

    const newState = state;
    setState(state);

    let newRemainingDuration = form.getFieldValue('newRemainingDuration');

    // ////

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }
    form?.setFieldsValue({ newRv: rvDefault ?? 0 });

    updateState({durationMax:newRemainingDuration, currentDuration: newRemainingDuration});

    calculate(
      objectid,
      rvDefault ?? 0,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleGpMethodChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }
    const newRv = form?.getFieldValue('newRv');
    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration');

    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');

    const gpMethod = form?.getFieldValue('gpMethod');

    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    const inPartialPayoffAmount = form?.getFieldValue('inPartialPayoffAmount');
    const inPartialPayoffFormula = form?.getFieldValue(
      'inPartialPayoffFormula'
    );
    const inPartialPayoffFeesAmount = form?.getFieldValue(
      'inPartialPayoffFeesAmount'
    );

    if (
      !inPartialPayoffAmount ||
      !inPartialPayoffFormula ||
      !inPartialPayoffFeesAmount
    ) {
      notification.error({
        message:
          'Please select the Partial Payoff section before selecting the Grace Period section',
      });
      return;
    }

    const newRate = form?.getFieldValue('newRate');

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    if (extendDuration && value !== 'NONE') {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    calculate(
      objectid,
      newRv,
      gpDuration,
      value,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleGpNominalRateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    //const gpNominalRate=form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');
    const newRv = form?.getFieldValue('newRv');
    const newRate = form?.getFieldValue('newRate');

    const inPartialPayoffAmount = form?.getFieldValue('inPartialPayoffAmount');
    const inPartialPayoffFormula = form?.getFieldValue(
      'inPartialPayoffFormula'
    );
    const inPartialPayoffFeesAmount = form?.getFieldValue(
      'inPartialPayoffFeesAmount'
    );

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      value,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleNewRemainingDurationChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');
    const newRv = form?.getFieldValue('newRv');
    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

    const newRate = form?.getFieldValue('newRate');


    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;
    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = value;

    if (extendDuration) {
      newRemainingDuration = value;
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleGpPeriodicityChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    //const gpPeriodicity=form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration = form?.getFieldValue('extendDuration');
    const newRv = form?.getFieldValue('newRv');
    const newRate = form?.getFieldValue('newRate');

    const inPartialPayoffAmount = form?.getFieldValue('inPartialPayoffAmount');
    const inPartialPayoffFormula = form?.getFieldValue(
      'inPartialPayoffFormula'
    );
    const inPartialPayoffFeesAmount = form?.getFieldValue(
      'inPartialPayoffFeesAmount'
    );

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;

    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');

    if (extendDuration) {
      newRemainingDuration = fremainDuration + gpDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    } else {
      newRemainingDuration = fremainDuration;
      form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });
    }

    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      value,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      newRate,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  const handleNewRateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }
    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');
    const newRv = form?.getFieldValue('newRv');
    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration = form?.getFieldValue('extendDuration');

    const remainDuration = notInvoicedSchedule?.filter(
      (e) => e.ctsduedate >= targetDate
    ).length;
    const fremainDuration = remainDuration !== undefined ? remainDuration : 0;

    let newRemainingDuration = form?.getFieldValue('newRemainingDuration');
    
    form?.setFieldsValue({ newRemainingDuration: newRemainingDuration });


    calculate(
      objectid,
      newRv,
      gpDuration,
      gpMethod,
      gpPeriodicity,
      gpNominalRate,
      extendDuration,
      newRemainingDuration,
      value,
      0,
      '',
      targetDate,
      newDueDate,
      defintMethod,
      defintNominalRate,
    );
  };

  
  const [elementID, setElementID] = useState(1);
  const getName = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };
  const calculate = debounce(
    async (
      ctrid: number,
      newRv: number,
      gpDuration: number,
      gpMethod: string,
      gpPeriodicity: string,
      gpNominalRate: number,
      extendDuration: boolean,
      newRemainingDuration: number,
      newRate: number,
      feesAmount: number,
      feesFormula: string,
      effectDate: string,
      newDueDate: string,
      defintMethod: string,
      defintNominalRate: number,
    ) => {
      updateState({ isLoading: true });
      console.log('unpaidList',unpaidList)

      await reschUnpaidInvoice({
        ctrid: ctrid,
        taskid: 0,
        gpDuration: isNil(gpDuration) ? 0 : gpDuration,
        gpMethod: gpMethod,
        gpPeriodicity: isNil(gpPeriodicity) ? '' : gpPeriodicity,
        gpNominalRate: isNil(gpNominalRate) ? 0 : gpNominalRate,
        extendDuration: isNil(extendDuration) ? true : extendDuration,
        newRemainingDuration:
          isNil(newRemainingDuration) || isNaN(newRemainingDuration)
            ? 0
            : newRemainingDuration,
        newRate: newRate,
        newRv: newRv,
        newDueDate: newDueDate,
        defintMethod: defintMethod,
        defintNominalRate: defintNominalRate,
        modid: 0,
        mode: 'CALCUL',
        invoiceFees: false,
        feesFormula: feesFormula,
        feesAmount: feesAmount,
        effectDate: effectDate,
        totalunpaidamount: contract?.totalunpaidamount ?? 0,
        ciUpnaidList: unpaidList
      })
        .then((resp) => {
          updateState({ isLoading: false });

          if (resp.code === '200') {
            notification.success({
              message: resp.message,
              duration: 3,
            });

            const clonedResp = _.cloneDeep(resp);
            const elements = clonedResp.data.conElements;
            
            // let elements = resp.data.conElements;
            let index = _.cloneDeep(elements).findIndex((e) => e.ctetype === 'FIN');

            let cteaprrate =
            _.cloneDeep(elements).find((e) => e.ctetype === 'FIN')?.cteaprrate ?? 0;

            let newRental =
            resp.data.conElements.find((e) => e.ctetype === 'FIN')
                ?.cterentalamount ?? 0;

            updateState({ newRental: newRental, cteaprrate: cteaprrate });

            // _.cloneDeep(elements)[index].conElemSchedules = !isNil(
            //   form?.getFieldValue('conElemSchedules')
            // )
            //   ? form
            //       ?.getFieldValue('conElemSchedules')
            //       ?.slice(
            //         0,
            //         form
            //           ?.getFieldValue('conElemSchedules')
            //           .findIndex(
            //             (item: any) =>
            //               item.ctsduedate === form?.getFieldValue('effectDate')
            //           )
            //       )
            //       ?.concat(_.cloneDeep(elements[index].conElemSchedules) ?? [])
            //   : [];

            const {
              FIN = [],
              SERV = [],
              FEES = [],
              COMM = [],
              FINSERV = [],
              //      } = groupBy(data.conElements || [], 'ctetype');
            } = groupBy(
              conElementToElement(_.cloneDeep(elements), _.cloneDeep(resp.data.offer)) || [],
              'ctetype'
            );

            form?.setFieldsValue({
              elements: {
                COMM,
                FEES,
                FIN,
                FINSERV,
                SERV,
              },
            });
            

          } else {
            notification.error({
              message: resp.message,
              duration: 0,
            });
          }
        })
        .catch((err) => {
          message.error(
            'Error in calculation. please contact the service provider'
          );
          updateState({ isLoading: false });
        });
    },
    1000
  );

  const getPArtAmount = () => {
    const ctepartmethod = form?.getFieldValue(
      getName('ctepartmethod', elementID)
    );

    var ctepartamount = 0;
    if (ctepartmethod === 'PROMO' || ctepartmethod === 'REDUCEFIN') {
      ctepartamount = isNaN(
        form?.getFieldValue(getName('ctepartamount', elementID))
      )
        ? 0
        : form?.getFieldValue(getName('ctepartamount', elementID));
    }
    return ctepartamount;
  };

  const debouncedCalculateNew = debounce((param: string) => {
    const cteid =
      contract?.conElements?.find((e) => e.ctetype === 'FIN')?.cteid ??
      form.getFieldValue('selectedElement');
    calculateNew(cteid, param);
  }, 1000);

  const calculateNew = (inCteid: number, param: string) => {
    // updateState({ isLoading: true });

    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.findIndex((item: any) => item.cteid === inCteid);
    console.log('index:', inCteid, '--', indexElement);
    const finElement = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
    ]) as PropElementResponse;

    // const finElement = contract?.conElements?.find((e) => e.ctetype === 'FIN');
    console.log('finElement', finElement, '-param', param);
    if (!finElement || finElement?.ctecalculationtype === null) {
      return;
    }
    var finamount = 0;
    let investamount = finElement.cteinvestamount;
    let firstPayment = 0; //finElement.ctefirstpayment

    var rvcoef = 0;
    var rvamount = 0;

    // const listassets = form?.getFieldValue('assets');
    const invest =
      form?.getFieldValue('cttype') === 'LEAD'
        ? form?.getFieldValue(getName('cteinvestamount', inCteid))
        : form?.getFieldValue('cttype') === 'PART'
        ? form?.getFieldValue('ctsyndmgpartamount')
        : form?.getFieldValue(getName('cteinvestamount', inCteid));

    if (param === 'FP') {
      firstPayment = finElement.ctefirstpayment;
    } else {
      firstPayment = !isNaN(finElement.ctefirstpaymentcoef)
        ? (finElement.ctefirstpaymentcoef * invest) / 100
        : finElement.ctefirstpaymentcoef;
    }
    if (param === 'RV') {
      rvamount = finElement.ctervamount;
    }

    const rvAmount = rvamount;

    const upfront = finElement.cteupfrontamount;

    let ctepartamount = getPArtAmount();
    const line: any = finElement.conElemSchedules?.find(
      (e: any) => e.ctsduedate === param
    );
    finamount =
      finElement.ctefinancedamount ?? investamount - upfront - ctepartamount;

    console.log('calc::', finElement?.ctecalculationtype);

    switch (finElement?.ctecalculationtype) {
      case 'SEASON':
        calculateSeasonal(inCteid);
        //OK
        break;
      case 'LINEAR':
        calculateLinearAndWeighted(
          inCteid,
          finElement,
          finamount,
          investamount,
          firstPayment,
          rvAmount
        );
        //OK
        break;
      case 'STEP':
        calculatePaymentSheduleStep(inCteid);
        break;
      case 'STEPWEIGH':
        calculateLinearAndWeighted(
          inCteid,
          finElement,
          finamount,
          investamount,
          0, //firstPayment
          rvAmount
        );
        //OK
        break;
    } // end switch calctype
  };

  const calculateSeasonal = (inCteid: number) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement];

    const FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as any[];

    // calculate FIN

    var finamount = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      // part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = finElement.ctefinancedamount;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      finEngine
        .calculateSeasonalSchedule({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'SEASON',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: 'NONE',
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(form?.getFieldValue('effectDate')),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inDuration: finElement?.cteduration,
            inFirstPayment: 0,
            inResidualValue:
              finElement?.ctervamount === null ? 0 : finElement?.ctervamount,
            inUpFrontAmount:
              finElement?.cteupfrontamount === null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  element.cteid === inCteid
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        conElemSteps: res.elementStep,
                      }
                    : element
                ),
              },
            });

            const conelemsteps = form?.getFieldValue([
              'elements',
              'FIN',
              0,
              'conElemSteps',
            ]);

            //if (conelemsteps!=null ) {

            const newconelem = conelemsteps.map((element: any) => {
              let rent = res.elementStep.filter(
                (e) => Number(e.ctesorder) === Number(element.ctesorder)
              );

              return {
                ...element,
                ctesrentalamount: rent[0].ctesrentalamount,
                status: 'VALID',
              };
            });

            const FIN = form?.getFieldValue(['elements', 'FIN']);
            let elements = form?.getFieldValue('elements');
            FIN[0].conElemSteps = newconelem;
            elements = { ...elements, FIN: FIN };

            form?.setFieldsValue({ elements: elements });

            message.success(res.message);

            calculateServAndComm(res, finElement, finamount, inCteid);
          } // end if success
        });

      /// end calculate FIN
    }
  }; //end calculation of PaymentShedule Seasonal :
  const calculateServAndComm = (
    res: any,
    finElement: PropElementResponse,
    finamount: number,
    inCteid: number
  ) => {
    // calculate FinServices ELEMENTs:
    // calculate Services ELEMENT:

    const finServElements = form
      ?.getFieldValue(['elements', 'FINSERV'])
      .filter((item: any) => item.cteidparent === inCteid);

    let ind = 0;
    for (var finserv of finServElements) {
      calculateFinServiceNew(
        finserv,
        finElement,
        finElement.ctestartdate,
        finElement.ctebilligdate,
        finamount,
        inCteid
      );
      ind = ind + 1;
    }

    // calculate Services ELEMENT:
    const servElements = form
      ?.getFieldValue(['elements', 'SERV'])
      .filter((item: any) => item.cteidparent === inCteid);
    ind = 0;
    for (var serv of servElements) {
      calculateServiceNew(
        serv,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
    // calculate FEES ELEMENT:
    const feesElements = form
      ?.getFieldValue(['elements', 'FEES'])
      .filter((item: any) => item.cteidparent === inCteid);
    ind = 0;
    for (var fees of feesElements) {
      calculateFeesNew(
        fees,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
    // calculate Commissions elements :
    // calculate Services ELEMENT:
    const commElements = form
      ?.getFieldValue(['elements', 'COMM'])
      .filter((item: any) => item.cteidparent === inCteid);

    ind = 0;
    for (var comm of commElements) {
      calculateCommissionNew(
        comm,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
  };

  const calculateFinServiceNew = (
    finserv: any,
    firstFinElement: any,
    ctinitstartdate: any,
    ctbillingdate: any,
    finamount: any,
    inCteid: number
  ) => {
    let finServamount = 0;
    if (finserv.serviceResponse?.servcalculationmethod === 'FIXED') {
      finServamount = finserv.serviceResponse.servfixedamount;
    } else {
      if (finserv.serviceResponse?.servcalculationmethod === 'PERCENT') {
        switch (finserv.serviceResponse.servbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * finserv.serviceResponse.servpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;

          case 'INVEST':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = finserv.cteinvestamount;
      }
    }

    //set finserv=firstFinElement :
    let newfinServ = {
      assetid: firstFinElement.assetid,
      conElemAssets: [],
      conElemSchedules: [] as any,
      conElemSteps: [],
      cteactuarialrate: 0,
      serviceResponse: finserv.serviceResponse,
      pricing: finserv.pricing,
      ctecalculationbasis: finserv.serviceResponse.servbasis,
      ctecalculationtype: 'LINEAR',
      ctecategory: finserv.ctecategory,
      ctedeferredinterest: 0,
      ctedeferredinterestmethod: firstFinElement.ctedeferredinterestmethod,
      ctedeferredinterestnominalrate:
        firstFinElement.ctedeferredinterestnominalrate,
      ctedepositamount: 0,
      ctedepositcoef: 0,
      ctedepositinterest: 0,
      ctedepositinterestmethod: 'NONE',
      ctedepositnominalrate: 0,
      ctedescription: finserv.ctedescription,
      ctedirection: 'IN',
      cteduration: firstFinElement.cteduration,
      cteendamount: 0,
      cteenddate: '',
      ctefinancedamount: finServamount,
      ctefirstpayment: 0,
      ctefirstpaymentcoef: 0,
      ctefirstpaymentdate: '',
      ctefree1: '',
      ctegraceperiodduration: firstFinElement.ctegraceperiodduration,
      ctegraceperiodmethod: firstFinElement.ctegraceperiodmethod,
      cteid: Math.floor(_.random(10000) * 10000),
      cteidparent: inCteid,
      cteinitialamount: finServamount,
      cteinstallmentamount: 0,
      cteinterestmethod: firstFinElement.cteinterestmethod,
      cteinvestamount: finServamount,
      ctenominalrate: firstFinElement.ctenominalrate,
      cteorder: finserv.cteorder,
      ctepartamount: 0,
      ctepartdays: 0,
      ctepartmethod: 'NONE',
      ctepartrate: 0,
      ctepaymentterm: firstFinElement.ctepaymentterm,
      cteperiodicity: firstFinElement.cteperiodicity,
      cteratebasis: firstFinElement.cteratebasis,
      cterateformula: firstFinElement.cterateformula,
      cterateperiodicity: firstFinElement.cterateperiodicity,
      cteratespread: firstFinElement.cteratespread,
      cterateterm: firstFinElement.cterateterm,
      cteratetype: firstFinElement.cteratetype,
      cterentalamount: 0,
      ctervamount: 0,
      ctervcoef: 0,
      ctestartamount: finServamount,
      ctestartdate: firstFinElement.ctestartdate,
      ctestatus: 'INIT',
      ctetype: 'FINSERV',
      cteunit: firstFinElement.cteunit,
      cteupfrontamount: 0,
      ctrid: 0,
      currcode: firstFinElement.currcode,
      last_action: '',
      prefinbasis: '0',
      prefinmethod: '',
      prefinnominalrate: 0,
      prefinperiodicity: '',
      prefinrateformula: '',
      prefinratetype: '',
      priid: finserv.priid,
      taxcode: firstFinElement.taxcode,
      tpid: firstFinElement.tpid,
      tpidparticipation: '',
    };

    finEngine
      .calculate({
        finReq: {
          inBillingDate: firstFinElement.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType: firstFinElement?.ctecalculationtype,
          inCountingbasis: firstFinElement?.cteratebasis,
          inDeferredMethod: firstFinElement?.ctedeferredinterestmethod,
          inDeferredRate: firstFinElement?.ctedeferredinterestnominalrate,
          inDepositAmount: 0,

          inDepositMethod: 'NONE',
          inDepositRate: 0,
          inDuration:
            firstFinElement?.cteduration == null
              ? 1
              : firstFinElement?.cteduration,
          inFinancedAmount: finServamount,
          inFirstInstallmentDate: '', //dateTimeToDate(firstFinElement?.ctestartdate),
          inFirstPayment: 0,
          inGracePeriodDuration:
            firstFinElement?.ctegraceperiodduration == null
              ? 0
              : firstFinElement?.ctegraceperiodduration,
          inGracePeriodMethod: firstFinElement?.ctegraceperiodmethod,
          inInstallmentAmount: 0,
          inInterestMethod: firstFinElement?.cteinterestmethod,
          inPartAmount: 0,
          inPartMethod: 'NONE',
          inPartNbDays: 0,
          inPartRate: 0,
          inPeriodicity: firstFinElement?.cteperiodicity,
          inPeriodicityUnit: firstFinElement?.cteunit,
          inRatePeriodicity: firstFinElement?.cterateperiodicity,
          inRateType: firstFinElement?.cteratetype,
          inRateValue:
            firstFinElement?.ctenominalrate == null
              ? 0
              : firstFinElement?.ctenominalrate,
          inResidualValue: 0,
          inRoundingAmount: getRounding(firstFinElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(firstFinElement.ctestartdate),
          inTaxcode: firstFinElement?.taxcode,
          inTaxrate: firstFinElement?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: firstFinElement?.ctepaymentterm,
          inUpFrontAmount: 0,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('FinService ' + res.message);

          newfinServ.conElemSchedules = res.paymentSchedule;
          newfinServ.cteactuarialrate = res.effectiverate;
          newfinServ.ctedeferredinterest = res.deferredInterest;
          newfinServ.ctedepositinterest = res.depositInterest;
          newfinServ.cteduration = res.duration;
          newfinServ.ctefinancedamount = res.financedamount;
          newfinServ.cteinstallmentamount = res.installmentamount;
          newfinServ.cterentalamount = res.installmentamount;
          const finServElements =
            form?.getFieldValue(['elements', 'FINSERV']) || [];

          form?.setFieldsValue({
            elements: {
              FINSERV: finServElements.map((element: any, index: any) => {
                return element.cteid === finserv.cteid ? newfinServ : element;
              }),
            },
          });
        }
      });
  };

  const calculateServiceNew = (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.serviceResponse.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.serviceResponse.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree: servElement.serviceResponse.servdurationdefault,

          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          const servElements = form?.getFieldValue(['elements', 'SERV']) || [];

          form?.setFieldsValue({
            elements: {
              SERV: servElements.map((element: any, index: any) =>
                element.cteid === servElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,

                      cteduration: res.duration,

                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
          // create new function to create new service out
          // add Servout
          // if supplier or there's out in response of service (serviceResponse)..
          // handlepricing and manual add of service=> pricing to element or new function...
        }
      });
  };

  const calculateFeesNew = (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.serviceResponse.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.serviceResponse.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree: servElement.serviceResponse.servdurationdefault,

          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Fees - ' + res.message);

          const feesElements = form?.getFieldValue(['elements', 'FEES']) || [];

          form?.setFieldsValue({
            elements: {
              FEES: feesElements.map((element: any, index: any) =>
                element.cteid === servElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,

                      cteduration: res.duration,

                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
        }
      });
  };

  const calculateCommissionNew = (
    commElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    let finServamount = 0;

    if (commElement.commissionResponse?.commcalculationmethod === 'FIXED') {
      finServamount = commElement.commissionResponse.commfixedamount;
    } else {
      if (commElement.commissionResponse?.commcalculationmethod === 'PERCENT') {
        switch (commElement.commissionResponse.commbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * commElement.commissionResponse.commpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;

          case 'INVEST':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = commElement.cteinstallmentamount;
      }
    }
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finServamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: commElement.ctecategory,
          inRoudingAmount: getRounding(commElement.currcode),
          inServcalculationmethod:
            commElement.commissionResponse.commcalculationmethod,
          inServfixedamount:
            commElement.commissionResponse.commfixedamount === null
              ? 0
              : commElement.commissionResponse.commfixedamount,
          inServiceduration: commElement.commissionResponse.commduration,
          inServpercentage:
            commElement.commissionResponse.commpercentage === null
              ? 0
              : commElement.commissionResponse.commpercentage,
          inTaxcode: commElement?.taxcode,
          inTaxrate: commElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: commElement.commissionResponse.commperiodicity,
          inServDurationFree:
            commElement.commissionResponse.commdurationdefault,

          inStartDate: startDate,
          inServbasis: commElement.commissionResponse.commbasis,

          inCalculatedamountbasis: 'ANNUAL',

          inMarginoncalcultedamount: 0,
          inAdditionalcostaftermargin: 0,

          servStep: [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Commission - ' + res.message);
          const commElements = form?.getFieldValue(['elements', 'COMM']) || [];

          form?.setFieldsValue({
            elements: {
              COMM: commElements.map((element: any, index: any) =>
                element.cteid === commElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteduration: res.duration,
                      cteinstallmentamount: res.inInstallmentAmount,
                      cterentalamount: res.inInstallmentAmount,
                    }
                  : element
              ),
            },
          });
        }
      });
  };

  const calculateLinearAndWeighted = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number,
    investamount: number,
    firstPayment: number,
    rvAmount: number
  ) => {
    finEngine
      .calculate({
        finReq: {
          inBillingDate: finElement?.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType: finElement?.ctecalculationtype,
          inCountingbasis: finElement?.cteratebasis,
          inDeferredMethod: 'NONE',
          inDeferredRate: finElement?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElement?.ctedepositamount == null
              ? 0
              : finElement?.ctedepositamount,
          inDepositMethod: finElement?.ctedepositinterestmethod,
          inDepositRate:
            finElement?.ctedepositinterestmethod === 'NONE'
              ? 0
              : finElement?.ctedepositnominalrate == null
              ? 0
              : finElement?.ctedepositnominalrate,
          inDuration: form?.getFieldValue('newRemainingDuration')
            ? form?.getFieldValue('newRemainingDuration')
            : finElement?.cteduration == null
            ? 1
            : finElement?.cteduration,
          inFinancedAmount: finamount,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: 0,
          inGracePeriodDuration:
            finElement?.ctegraceperiodduration == null
              ? 0
              : finElement?.ctegraceperiodduration,
          inGracePeriodMethod: finElement?.ctegraceperiodmethod,
          inInstallmentAmount: finElement?.cteinstallmentamount,
          inInterestMethod: finElement?.cteinterestmethod,
          inPartAmount:
            finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
          inPartMethod: finElement?.ctepartmethod
            ? finElement?.ctepartmethod
            : 'NONE',
          inPartNbDays:
            finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
          inPartRate:
            finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
          inPeriodicity: finElement?.cteperiodicity,
          inPeriodicityUnit: finElement?.cteunit,
          inRatePeriodicity: Number(finElement?.cterateperiodicity),
          inRateType: finElement?.cteratetype,
          inRateValue:
            finElement?.ctenominalrate == null ? 0 : finElement?.ctenominalrate,
          inResidualValue: rvAmount == null ? 0 : rvAmount,
          inRoundingAmount: getRounding(finElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inTaxcode: finElement?.taxcode,
          inTaxrate: finElement?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: finElement?.ctepaymentterm,
          inUpFrontAmount:
            finElement?.cteupfrontamount == null
              ? 0
              : finElement?.cteupfrontamount,
        },
      })
      .then((res) => {
        console.log('tttttttttttttt');
        if (res.success) {
          // calculate RVI :

          // calculate Weighted Steps :
          if (finElement?.ctecalculationtype === 'STEPWEIGH') {
            // add Steps based on Config :
            //finElement.conElemSteps = [];

            //finElement.conElemSteps = calculateREC(
            // eslint-disable-next-line no-unused-vars
            let steps = calculateREC(
              finamount,
              dateToString(finElement?.ctestartdate),
              0,
              finElement.conElemSteps[0],
              finElement,
              res.installmentamount,
              []
            );

            // end .then

            // end loop on steps
          } // end if STEPWEIGH
          // end if STEPWEIGH
          updateState({ isLoading: false });

          message.success(res.message);

          const FinElements = form?.getFieldValue(['elements', 'FIN']) || [];

          form?.setFieldsValue({
            elements: {
              FIN: FinElements.map((element: any, index: number) =>
                element.cteid === inCteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteactuarialrate: res.effectiverate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedepositinterest: res.depositInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      conElemSteps: finElement.conElemSteps,
                      cteduration: res.duration,
                      ctefinancedamount: res.financedamount,
                      ctefirstpayment:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : res.inFirstPayment,
                      ctefirstpaymentcoef:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : (res.inFirstPayment / investamount) * 100,
                      cteinstallmentamount: res.installmentamount,
                      cterentalamount:
                        res.installmentamount - res.depositInterest,
                      // ctervamount: res.residualvalue,
                      ctervcoef: (res.residualvalue / investamount) * 100,
                    }
                  : element
              ),
            },
          });
          updateState({
            newRental: res.installmentamount - res.depositInterest,
            // cteaprrate: cteaprrate
          });

          calculateIRV(
            inCteid,
            investamount,
            finamount,
            finElement.ctestartdate,
            finElement.ctebilligdate,
            finElement.ctepaymentterm,
            res.paymentSchedule
          );

          calculateServAndComm(res, finElement, finamount, inCteid);
        }
      }); // end then
  };

  const calculateREC = (
    stepStartamount: any,
    stepStartdate: any,
    i: number,
    currentStep: any,
    finElement: any,
    installmentamount: any,
    finElementconElemStep: any
  ) => {
    if (i === finElement.conElemSteps.length) {
      calculatePaymentSheduleWeightedStep('STEPWEIGH', finElementconElemStep);
      return finElementconElemStep;
    } else {
      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod:
              finElement.conElemSteps.length - 1 === i ? 'INST' : 'OUTSTAND',
            inCalculationType: finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: currentStep.ctesduration,
            inFinancedAmount: stepStartamount ?? 0,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount:
              finElement.conElemSteps.length - 1 === i
                ? 0
                : (currentStep.ctesrentalcoef * installmentamount) / 100,
            inInterestMethod: i === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: currentStep.ctesperiodicity,
            inPeriodicityUnit: currentStep.ctesperiodicityunit ?? 'M',
            inRatePeriodicity: Number(finElement?.cterateperiodicity),
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue:
              finElement.conElemSteps.length - 1 === i
                ? finElement.ctervamount
                : 0, //e.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: stepStartdate, //dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((resStep) => {
          if (resStep.success) {
            // update Step :

            finElementconElemStep.push({
              cteid: finElement.cteid,
              ctesamortizedcoef: (
                (resStep.residualvalue / finElement.cteinvestamount) *
                100
              ).toFixed(3),
              ctesduration: currentStep.ctesduration,
              ctesid: currentStep.ctesid,
              ctesorder: currentStep.ctesorder,
              ctesoutstandingamount: resStep.residualvalue,
              ctesperiodicity: currentStep.ctesperiodicity,
              ctesperiodicityunit: currentStep.ctesperiodicityunit ?? 'M',
              ctesperiodicityunitlabel: '',
              ctesrentalamount: resStep.installmentamount, //*e.ctesrentalcoef/100,
              ctesrentalcoef: (
                (resStep.installmentamount / installmentamount) *
                100
              ).toFixed(3),
              ctrid: finElement.ctrid,
              status: 'VALID',
            });

            stepStartamount = resStep.residualvalue;
            stepStartdate = resStep.paymentSchedule.find(
              (e) => e.ctstype === 'RV'
            )?.ctsenddate;

            calculateREC(
              stepStartamount,
              stepStartdate,
              i + 1,
              finElement.conElemSteps[i + 1],
              finElement,
              installmentamount,
              finElementconElemStep
            );
          } // end success calculation
        });

      //return finElementconElemStep;
    }
  };

  const calculateIRV = async (
    inCteid: number,
    investAmount: any,
    finAmount: any,
    startDate: any,
    inBillingDate: string,
    inTerm: string,
    finSchedule: any
  ) => {
    const listassets = form?.getFieldValue('assets');
    listassets.forEach(async (asset: any) => {
      if (
        asset.cteid === inCteid &&
        asset.listrv?.find((e: any) => e.rvtype === 'IRV')
      ) {
        await finEngine
          .calculateIRVSchedule({
            irvReq: {
              finSchedule: finSchedule,
              inInvestAmount: investAmount,
              inFinAmount: finAmount,
              inAssetAmount: asset.assetnetamount,
              inStartDate: startDate,
              inBillingDate: inBillingDate,
              inTerm: inTerm,
              inRoundingAmount: 2,
              assetRvCalcParams: asset.listrv.filter(
                (e: any) => e.rvtype === 'IRV'
              ),
            },
          })
          .then((res2: any) => {
            if (res2.success) {
              message.success('IRV - ' + res2.message);
              form?.setFieldsValue({
                assets: listassets.map((ele: any) => {
                  if (asset.assetid === ele.assetid)
                    return { ...ele, irvSchedule: res2.irvSchedule };
                  else return ele;
                }),
              });
            }
          });
      }
    });
  };

  const calculatePaymentSheduleWeightedStep = (
    method: string,
    FinElemStep: any
  ) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);

    const finElement = FinElements[indexElement];

    var finamount = 0;
    const investamount = finElement.cteinvestamount;
    // eslint-disable-next-line no-unused-vars
    const firstPayment = finElement.ctefirstpayment;
    // eslint-disable-next-line no-unused-vars
    const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = investamount - upfront - part;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method ?? 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode: '',
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);
            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              // eslint-disable-next-line no-unused-vars
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              // eslint-disable-next-line no-unused-vars
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        conElemSteps: res.elementStep,
                      }
                    : element
                ),
              },
            });
          } else {
            message.error(res.message);
          }
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const calculatePaymentSheduleStep = (inCteid: number) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement !== -1 ? indexElement : 0];

    let FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement !== -1 ? indexElement : 0,
      'conElemSteps',
    ]) as any[];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // eslint-disable-next-line no-unused-vars
    const firstPayment = finElement.ctefirstpayment;
    // eslint-disable-next-line no-unused-vars
    const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = investamount - upfront - part;

    if (
      FinElemStep === null ||
      FinElemStep === undefined ||
      isEmpty(FinElemStep)
    ) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: PropElemStepRequest) => {
        s.ctesoutstandingamount = (investamount * s.ctesamortizedcoef) / 100;
      });

      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode: '',
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);

            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }
            // setAssetRvAmount(_.last(res.elementStep)?.ctesoutstandingamount);

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        ctedeferredinterestnominalrate: res.inDeferredRate,
                        ctedeferredinterest: res.deferredInterest,
                        ctedepositnominalrate: res.inDepositRate,
                        ctedepositinterest: res.depositInterest,
                        ctervamount: rvamount,
                        ctervcoef: rvcoef,
                        ctefirstpayment: 0,
                        ctefirstpaymentcoef: 0,
                        conElemSteps: res.elementStep.map((step) => {
                          return {
                            ...step,
                            ctesid: Math.floor(_.random(10000) * 10000000), //theres no ctesid received
                            ctesamortizedcoef: step.ctesamortizedcoef,
                          };
                        }),
                      }
                    : element
                ),
              },
            });

            calculateServAndComm(res, finElement, finamount, inCteid);
          } else {
            message.error(res.message);
          }
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  useEffect(() => {

    if(clientInvoices){
      let unpaids = clientInvoices.filter(
        (ci) => moment(ci.cidocdate).format('YYYY-MM-DD') < moment(Date.now()).format('YYYY-MM-DD') && ci.cidueamount > 0
      );
      setUnpaidList(unpaids);
    }

    if (contract) {
      const elemFin = contract?.conElements?.find((e) => e.ctetype === 'FIN');
      const {
        FIN = [],
        SERV = [],
        FEES = [],
        COMM = [],
        FINSERV = [],
        //      } = groupBy(data.conElements || [], 'ctetype');
      } = groupBy(
        conElementToElement(contract.conElements, contract.offer) || [],
        'ctetype'
      );

      const elements = {
        COMM,
        FEES,
        FIN,
        FINSERV,
        SERV,
      };
      console.log('unpaidList 2222::',unpaidList)

      form?.setFieldsValue({
        event: 'tabreschunpaidinv',
        elements: elements,
        defintMethod: elemFin?.ctedeferredinterestmethod,
        defintNominalRate: elemFin?.ctedeferredinterestnominalrate,
        newDueDate: elemFin?.ctebilligdate,
        gpDuration: 0,
        // gpMethod: 'INV',
        gpPeriodicity: elemFin?.cteperiodicity,
        gpNominalRate: elemFin?.ctenominalrate,
        extendDuration: true,
        newRate: elemFin?.ctenominalrate,
        newRemainingDuration: elemFin?.cteduration,
        mode: 'SIMUL',
        conElemSchedules: contract?.conElements?.find(
          (e) => e.ctetype === 'FIN'
        )?.conElemSchedules,
        totalunpaidamount: contract?.totalunpaidamount,
        currentDuration: state.currentDuration,
        // ciUpnaidList: unpaidList
      });
    }
  }, [contract, form, clientInvoices]);
  
  useEffect(() => {
    if (unpaidList.length > 0) {
      console.log('form with unpaidList:', unpaidList);
      form?.setFieldsValue({
        ciUpnaidList: unpaidList,
      });
    }
  }, [unpaidList]);
  

  return (
    <DF.Provider
      pagcode="tabreschunpaidinv"
      entity={object}
      entityid={objectid}
    >
      <Spin
        spinning={state.isLoading || isLoading}
        tip="Please wait..."
        delay={500}
      >
        <Row gutter={[8, 8]}>
          <UtinaCard
            level={5}
            comcode="EffectDate"
            styleCard={{
              color: '#000',
              paddingTop: 20,
              paddingBottom: 25,
            }}
            lg={7}
          >
            <Row>
              <FormInput
                col
                xs={20}
                name="effectDate"
                rules={[{ required: true }]}
              >
                <Select
                  defaultValue=""
                  size="middle"
                  style={{ width: '100%' }}
                  onChange={handleEffectDateChange}
                >
                  {optionDates}
                </Select>
              </FormInput>
            </Row>
            <Row>
              <FormInput col xs={14} name="mode" rules={[{ required: true }]}>
                <Radio.Group
                  options={optionsMode}
                  defaultValue="SIMUL"
                  optionType="button"
                  disabled={state.isModSelected}
                />
              </FormInput>
              <FormInput col xs={10} name="modid">
                <Select
                  size="middle"
                  allowClear
                  style={{ width: '100%' }}
                  onChange={(e: number) => handleFinModSelect(e)}
                  loading={isFetching}
                >
                  {optionModListValid}
                </Select>
              </FormInput>
            </Row>
          </UtinaCard>
          <UtinaCard
            level={5}
            comcode="SituationAtEffectDate"
            styleCard={{
              color: '#000',
              paddingTop: 20,
              paddingBottom: 25,
            }}
            lg={8}
          >
            <Row gutter={8}>
              <FormInput col xs={12} name="totalunpaidamount">
                <Text>{toCurrency(contract?.totalunpaidamount,contract?.currcode)}</Text>
              </FormInput>
              
              <FormInput col xs={12} name="newRental">
                <Text strong type="danger">
                  {toCurrency(state.newRental, contract?.currcode)}
                </Text>
              </FormInput>
            </Row>
            <Row gutter={8}>
              <FormInput col xs={12} name="currentDuration">
                <Text>{state.currentDuration}</Text>
              </FormInput>
              <FormInput col xs={12} name="remainDuration">
                <Text>
                  {state.remainDuration + ' / ' + durationDefault}
                </Text>
              </FormInput>
              <Form.Item
                shouldUpdate={shouldUpdateCompare([
                  'conElemSchedules',
                  'effectDate',
                  'elements',
                ])}
                noStyle
              >
                {({ getFieldValue }) => {
                  return (
                    <FinancialScheduleModal
                      comcode="newSchedule"
                      finElement={getFieldValue(['elements', 'FIN', 0])}
                      loading={Loading}
                      currcode={
                        contract?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      controller={
                        <ScheduleButton
                          size="large"
                          comcode="newSchedule"
                          twoToneColor="green"
                        ></ScheduleButton>
                      }
                    />
                  );
                }}
              </Form.Item>
            </Row>
          </UtinaCard>
          {unpaidList != undefined && (
            <UtinaCard
              level={5}
              comcode="UnpaidList"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={8}
            >
              <Row gutter={16} style={{ fontWeight: 'bold', color: '#f5222d', marginBottom: 8 }}>
                <Col span={8}><GetLabel label="cireference"/></Col>
                <Col span={8}><GetLabel label="cigrosstotal"/></Col>
                <Col span={8}><GetLabel label="cidueamount"/></Col>
              </Row>
              {unpaidList?.map((unpaid, index) => (
                <Row key={index} gutter={16} style={{ marginBottom: 8 }}>
                  <Col span={8}>{unpaid.cireference}</Col>
                  <Col span={8}>{toCurrency(unpaid.cigrosstotal,unpaid.currcode)}</Col>
                  <Col span={8}>{toCurrency(unpaid.cidueamount,unpaid.currcode)}</Col>
                </Row>
              ))}
              {/* <Table
                dataSource={unpaidList}
                columns={columns}
                rowKey={(record) => record.ciid}
              /> */}
            </UtinaCard>
          )}
        </Row>
        <Row gutter={30} style={{ paddingLeft: 10 }}>
          <UtinaCard
            level={5}
            comcode="ChangeBillingDay"
            styleCard={{
              color: '#000',
              paddingTop: 10,
              paddingBottom: 10,
            }}
            lg={12}
          >
            <Row gutter={30}>
              <FormInput col xs={4} name="currentDueDate">
                <Text>{dueDateDefault}</Text>
              </FormInput>
              <FormInput
                col
                xs={5}
                name="newDueDate"
                rules={[{ required: true }]}
              >
                <ParListSelect
                  disabled={state.isModSelected}
                  parcode="BILLDATE"
                  onSelected={handleDueDateChange}
                />
              </FormInput>
              <FormInput
                col
                xs={8}
                name="defintMethod"
                rules={[{ required: true }]}
              >
                <ParListSelect
                  parcode="CTEDEFINT"
                  disabled={state.isModSelected}
                  onSelected={handledefintMethodChange}
                />
              </FormInput>
              <Form.Item
                shouldUpdate={shouldUpdateCompare('defintMethod')}
                noStyle
              >
                {({ getFieldValue }) =>
                  getFieldValue('defintMethod') !== 'NONE' && (
                    <FormInput
                      col
                      xs={7}
                      name="defintNominalRate"
                      rules={[{ required: true }]}
                    >
                      <InputRate
                        style={{ width: '100%' }}
                        disabled={state.isModSelected}
                        onChange={handledefintNominalRateChange}
                      />
                    </FormInput>
                  )
                }
              </Form.Item>
            </Row>
          </UtinaCard>

          <UtinaCard
            level={5}
            comcode="AddGracePeriod"
            styleCard={{
              color: '#000',
              paddingTop: 20,
              paddingBottom: 25,
            }}
            lg={11}
          >
            <Row gutter={32}>
              <FormInput
                col
                xs={5}
                name="gpMethod"
                rules={[{ required: true }]}
              >
                <ParListSelect
                  parcode="GPMETHOD"
                  onSelected={handleGpMethodChange}
                  disabled={state.isModSelected}
                />
              </FormInput>
              <Form.Item shouldUpdate={shouldUpdateCompare('gpMethod')} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('gpMethod') !== 'NONE' && (
                    <>
                      <FormInput
                        col
                        xs={6}
                        name="gpDuration"
                        rules={[{ required: true }]}
                      >
                        <InputNumber
                          disabled={state.isModSelected}
                          onChange={handleGpDurationChange}
                        />
                      </FormInput>
                      <FormInput
                        col
                        xs={6}
                        name="gpPeriodicity"
                        rules={[{ required: true }]}
                      >
                        <ParListSelect
                          parcode="PERIOD"
                          onSelected={handleGpPeriodicityChange}
                          disabled={state.isModSelected}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={6}
                        name="gpNominalRate"
                        rules={[{ required: true }]}
                      >
                        <InputRate
                          onChange={handleGpNominalRateChange}
                          disabled={state.isModSelected}
                        />
                      </FormInput>
                    </>
                  )
                }
              </Form.Item>
            </Row>
          </UtinaCard>
        </Row>

        <UtinaCard
          level={5}
          comcode="ChangeDurationandRate"
          styleCard={{
            color: '#000',
            paddingTop: 20,
            paddingBottom: 25,
          }}
          lg={24}
        >
          <Row gutter={32}>
            <FormInput
              col
              xs={12}
              name="newRemainingDuration"
              rules={[{ required: true }]}
            >
              <SliderWithInput
                disabled={
                  form?.getFieldValue('extendDuration') === false ||
                  state.isModSelected
                }
                min={0}
                max={state.durationMax}
                precision={0}
                defaultValue={durationDefault}
                onChange={handleNewRemainingDurationChange}
              />
            </FormInput>
            <FormInput col xs={6} name="newRate" rules={[{ required: true }]}>
              <InputRate
                onChange={handleNewRateChange}
                disabled={state.isModSelected}
              />
            </FormInput>
            <FormInput col xs={6} name="cteaprrate">
              <Text strong>{toRate(state.cteaprrate)}</Text>
            </FormInput>
          </Row>
        </UtinaCard>
      </Spin>
    </DF.Provider>
  );
};
export default TabReschUnpaidInv;
